import React,{useState} from "react";
import { RCCButton, RCCGrid, RCCPopover } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import IComponentAudit from "./interface";
import Photo from "../Photo";
import Phrase from "./styles";

const Audit: React.FC<IComponentAudit> = ({
	data,
	type,
	position
}) => {
	const { translate, currentLanguage } = useTranslation();
	const [visible,setVisible] = useState(false);
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const popOver = () => (
		<RCCPopover
			color="grey"
			header={{
				title:translate("Auditoria")
			}}
			position={position||"leftEnd"}
			body={{
				custom:
				<div className="popover-body" style={{width:"max-content",padding:"5px 10px 5px 20px"}}>
					<RCCGrid 
						item 
						container
						alignItems="center"
						justifyContent="flex-end"
					>
						<Phrase style={{textAlign:"end"}}>{translate("Criado por")}:</Phrase>
						<Photo 
							width={20}
							height={20}
							hover={false}
							name={data.createdByName||""}
							link={data.createdByImage && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.createdByImage}`}
						/>
						<Phrase>
							{data.createdByName}  {data.dateCreated && formatDate(new Date(data.dateCreated),currentLanguage, true)}
						</Phrase>
					</RCCGrid>
					{data.modifiedByName &&
						<RCCGrid 
							item 
							container
							alignItems="center"
							justifyContent="flex-end">
							<Phrase style={{textAlign:"end"}}>{translate("Alterado por")}:</Phrase>
							<Photo
								width={20}
								height={20}
								hover={false}
								name={data.modifiedByName||""}
								link={data.modifiedByImage && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.modifiedByImage}`}
							/>
							<Phrase>
								{data.modifiedByName}  {data.dateModified && formatDate(new Date(data.dateModified),currentLanguage, true)}
							</Phrase>
						</RCCGrid>
					}
				</div>
			}}
		>
			<RCCButton icon={{name: "user", color: "#FFF", size: 13}} onClick={() => setVisible(!visible)}></RCCButton>
		</RCCPopover>
	);

	const expand = () => (
		<div>
			<div style={{display:"flex",justifyContent:"flex-end"}}>
				<RCCButton icon={{name: "user", color: "#FFF", size: 11}} onClick={() => setVisible(!visible)}></RCCButton>
			</div>
			{visible && 
				<div style={{right:"100%",width:"23vw",minWidth:"100%"}}>
					<RCCGrid item container>
						<RCCGrid item container xs={4} justifyContent="flex-end" alignItems="center">
							<Phrase style={{textAlign:"end"}}>{translate("Criado por")}:</Phrase>
						</RCCGrid>
						<RCCGrid container item wrap="nowrap" xs={8} alignItems="center">
							<Photo 
								width={20}
								height={20}
								hover={false}
								name={data.createdByName||""}
								link={data.createdByImage && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.createdByImage}`}
							/>
							<Phrase>{data.createdByName}  {data.dateCreated && formatDate(new Date(data.dateCreated),currentLanguage, true)}</Phrase>
						</RCCGrid>
					</RCCGrid>
					{data.modifiedByName &&
						<RCCGrid item container>
							<RCCGrid item container xs={4} justifyContent="flex-end" alignItems="center">
								<Phrase style={{textAlign:"end"}}>{translate("Alterado por")}:</Phrase>
							</RCCGrid>
							<RCCGrid item container wrap="nowrap" xs={8} alignItems="center">
								<Photo 
									width={20}
									height={20}
									hover={false}
									name={data.modifiedByName||""}
									link={data.modifiedByImage && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.modifiedByImage}`}
								/>
								<Phrase>{data.modifiedByName}  {data.dateModified && formatDate(new Date(data.dateModified),currentLanguage, true)}</Phrase>
							</RCCGrid>
						</RCCGrid>
					}
				</div>}
		</div>
	);

	return(
		<>
			{
				data.createdByName? 
					<>
						{(type==="pop" || type===undefined) &&popOver() }
						{(type==="expand") && expand()}
					</>
					:
					null
			}
		</>
	);
};

export default Audit;

